class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 800);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        this.handleCustomSorting(this);

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, section)
                : FacetFiltersForm.renderSectionFromFetch(url, event, section);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event, section) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderSection(html, event, section);

            });
    }

    static renderSectionFromCache(filterDataUrl, event, section) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderSection(html, event, section);
    }

    static renderSection(html, event, section) {
        if (section.render === 'collection-carousel') {
            FacetFiltersForm.renderCollectionCarousel(html, section);
            return;
        }

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('ProductGridContainer').innerHTML;

        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
            });
    }

    static renderCollectionCarousel(html, section) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const sourceContainer = FacetFiltersForm.getCollectionCarouselContainer(section.section, parsedHTML);
        const targetContainer = FacetFiltersForm.getCollectionCarouselContainer(section.section);

        if (!sourceContainer || !targetContainer) return;

        if (window.CollectionMetafieldCarouselSection) {
            window.CollectionMetafieldCarouselSection.destroy(targetContainer);
        }

        targetContainer.innerHTML = sourceContainer.innerHTML;

        if (window.CollectionMetafieldCarouselSection) {
            window.CollectionMetafieldCarouselSection.init(targetContainer);
        }
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
        const desktopCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop').innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = desktopCount;
            containerDesktop.classList.remove('loading');
        }
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );
        const facetDetailsElementsFromDom = document.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );

        // Remove facets that are no longer returned from the server
        Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
            if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
                currentElement.remove();
            }
        });

        const matchesId = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.id === jsFilter.id : false;
        };

        const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
        const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

        facetsToRender.forEach((elementToRender, index) => {
            const currentElement = document.getElementById(elementToRender.id);
            // Element already rendered in the DOM so just update the innerHTML
            if (currentElement) {
                document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
            } else {
                if (index > 0) {
                    const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
                    // Same facet type (eg horizontal/vertical or drawer/mobile)
                    if (elementToRender.className === previousElementClassName) {
                        document.getElementById(previousElementId).after(elementToRender);
                        return;
                    }
                }

                if (elementToRender.parentElement) {
                    document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
                }
            }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) {
            const closestJSFilterID = event.target.closest('.js-filter').id;

            if (closestJSFilterID) {
                FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
                FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

                const newFacetDetailsElement = document.getElementById(closestJSFilterID);
                const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
                    ? `.mobile-facets__close-button`
                    : `.facets__summary`;
                const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

                const isTextInput = event.target.getAttribute('type') === 'text';

                if (newElementToActivate && !isTextInput) newElementToActivate.focus();
            }
        }
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            let selectorEl = document.querySelector(selector);
            selectorEl.innerHTML = html.querySelector(selector).innerHTML;

            if (selector === '.sorting') {
                let faceFilterForm = selectorEl.closest('facet-filters-form');
                faceFilterForm.handleCustomSorting(faceFilterForm);
            }
        });

        const filterToggleContentSelectors = ['[data-mobile-filter-toggle-content]', '[data-desktop-filter-toggle-content]'];

        filterToggleContentSelectors.forEach((selector) => {
            const sourceElement = html.querySelector(selector);
            const targetElement = document.querySelector(selector);
            if (!sourceElement || !targetElement) return;

            targetElement.innerHTML = sourceElement.innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
        document.getElementById('FacetFiltersFormMobile')?.closest('mobile-filter-drawer')?.bindEvents?.();
        bindMobileFilterScrollMore();
    }

    static renderCounts(source, target) {
        const targetSummary = target.querySelector('.facets__summary');
        const sourceSummary = source.querySelector('.facets__summary');

        if (sourceSummary && targetSummary) {
            targetSummary.outerHTML = sourceSummary.outerHTML;
        }

        const targetHeaderElement = target.querySelector('.facets__header');
        const sourceHeaderElement = source.querySelector('.facets__header');

        if (sourceHeaderElement && targetHeaderElement) {
            targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
        }

        const targetWrapElement = target.querySelector('.facets-wrap');
        const sourceWrapElement = source.querySelector('.facets-wrap');

        if (sourceWrapElement && targetWrapElement) {
            const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
            if (isShowingMore) {
                sourceWrapElement
                    .querySelectorAll('.facets__item.hidden')
                    .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
            }

            targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
    }

    static renderMobileCounts(source, target) {
        const targetFacetsList = target.querySelector('.mobile-facets__list');
        const sourceFacetsList = source.querySelector('.mobile-facets__list');

        if (sourceFacetsList && targetFacetsList) {
            targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        const sections = [
            {
                section: document.getElementById('product-grid').dataset.id,
                render: 'product-grid',
            },
        ];

        document.querySelectorAll('[data-collection-metafield-carousel-container][data-section-id]').forEach((container) => {
            sections.push({
                section: container.dataset.sectionId,
                render: 'collection-carousel',
            });
        });

        return sections;
    }

    static getCollectionCarouselContainer(sectionId, root = document) {
        return Array.from(root.querySelectorAll('[data-collection-metafield-carousel-container]')).find((container) => {
            return container.dataset.sectionId === sectionId;
        });
    }

    handleCustomSorting(faceFilterForm) {
        faceFilterForm.querySelectorAll('[data-sort-option]').forEach(sortOptionEl => {
            sortOptionEl.addEventListener('click', (event) => {
                faceFilterForm?.querySelectorAll('[data-sort-option]').forEach(sortOptionEl => {
                    sortOptionEl.removeAttribute('selected', true);
                })
                sortOptionEl.setAttribute('selected', true);

                let sortValue = sortOptionEl.getAttribute('data-sort-option');
                sortValue = sortValue ? sortValue : 'manual';
                faceFilterForm.querySelector('input[name="sort_by"]')?.setAttribute('value', sortValue);

                let sortSelectedTextEl = faceFilterForm.querySelector('[data-sort-selected]');
                if (sortSelectedTextEl) {
                    let formattedSortValue = sortValue.replace('-', ' ').replace('manual', 'featured');
                    sortSelectedTextEl.innerHTML = formattedSortValue.charAt(0).toUpperCase() + formattedSortValue.slice(1);
                }

                faceFilterForm.onSubmitHandler(event);
            });
        });
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        formData.delete('range_min_price');
        formData.delete('range_max_price');
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetSortFormMobile' || event.target.closest('form').id === 'FacetFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'FacetSortFormMobile' || form.id === 'FacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function bindMobileFilterScrollMore() {
    const modal = document.getElementById('mobile-filter-model');
    const scrollContainer = modal?.querySelector('[data-mobile-filter-scroll-container]');
    const scrollBadge = modal?.querySelector('[data-mobile-filter-scroll-more]');

    if (!modal || !scrollContainer || !scrollBadge) return;

    if (modal.dataset.mobileFilterScrollMoreBound === 'true') {
        modal.mobileFilterScrollMoreUpdate?.();
        return;
    }

    const updateScrollMore = () => {
        if (scrollContainer.clientHeight <= 0) {
            scrollContainer.classList.remove('has-scroll-more');
            scrollBadge.classList.remove('is-visible');
            return;
        }

        const scrollRemaining = scrollContainer.scrollHeight - scrollContainer.clientHeight - scrollContainer.scrollTop;
        const hasScrollMore = scrollRemaining > 2;

        scrollContainer.classList.toggle('has-scroll-more', hasScrollMore);
        scrollBadge.classList.toggle('is-visible', hasScrollMore);
    };

    const updateAfterLayout = () => {
        updateScrollMore();
        window.requestAnimationFrame(updateScrollMore);
        window.setTimeout(updateScrollMore, 450);
    };

    modal.dataset.mobileFilterScrollMoreBound = 'true';
    modal.mobileFilterScrollMoreUpdate = updateAfterLayout;

    scrollContainer.addEventListener('scroll', updateScrollMore, { passive: true });
    modal.addEventListener('toggle', updateAfterLayout, true);
    window.addEventListener('resize', updateAfterLayout);

    const observer = new MutationObserver(updateAfterLayout);
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    updateAfterLayout();
}

bindMobileFilterScrollMore();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
        });
        this.querySelectorAll('input[type="text"]').forEach((element) => {
            element.addEventListener('focus', this.onTextInputFocus.bind(this));
            element.addEventListener('input', this.onTextInputInput.bind(this));
            element.addEventListener('blur', this.onTextInputBlur.bind(this));
        });
        this.querySelectorAll('input[type="range"]').forEach(element => {
            let inputLabel = this.querySelector(`#${element.name}`);
            element.addEventListener('input', () => this.updateLabelPosition(element, inputLabel));
        })
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        if (event.currentTarget.dataset.fallbackFilled === 'true') return;

        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    onTextInputFocus(event) {
        const input = event.currentTarget;

        if (input.value.trim() === '') {
            const fallbackValue = input.dataset.fallbackValue || input.getAttribute('placeholder') || '';

            if (fallbackValue) {
                input.value = fallbackValue;
                input.dataset.fallbackFilled = 'true';
            }
        }

        window.requestAnimationFrame(() => input.select());
    }

    onTextInputInput(event) {
        const input = event.currentTarget;
        const sanitizedValue = input.value.replace(/[^0-9.,' ]/g, '');

        if (input.value !== sanitizedValue) input.value = sanitizedValue;

        if (input.dataset.fallbackFilled !== 'true') return;

        const fallbackValue = input.dataset.fallbackValue || input.getAttribute('placeholder') || '';
        if (input.value !== fallbackValue) delete input.dataset.fallbackFilled;
    }

    onTextInputBlur(event) {
        const input = event.currentTarget;

        if (input.dataset.fallbackFilled !== 'true') return;

        const fallbackValue = input.dataset.fallbackValue || input.getAttribute('placeholder') || '';
        if (input.value === fallbackValue) input.value = '';

        delete input.dataset.fallbackFilled;
    }

    onKeyDown(event) {
        if (event.metaKey || event.ctrlKey) return;

        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Home|End|Delete|Escape/;
        if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        const minValue = this.getNumericValue(minInput.value);
        const maxValue = this.getNumericValue(maxInput.value);

        if (!Number.isNaN(maxValue)) minInput.setAttribute('data-max', maxValue);
        if (!Number.isNaN(minValue)) maxInput.setAttribute('data-min', minValue);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));

        let rangeMaxInput = this.querySelector(`input[data-name="${maxInput.name}"]`);
        let rangeMinInput = this.querySelector(`input[data-name="${minInput.name}"]`);
        if (rangeMaxInput && !Number.isNaN(maxValue)) rangeMinInput.setAttribute('data-max', maxValue);
        if (rangeMinInput && !Number.isNaN(minValue)) rangeMaxInput.setAttribute('data-min', minValue);
        if (rangeMinInput && minInput.value === '') rangeMaxInput.setAttribute('data-min', 0);
        if (rangeMaxInput && maxInput.value === '') rangeMinInput.setAttribute('data-max', rangeMaxInput.getAttribute('data-max'));
    }

    adjustToValidValues(input) {
        let priceDataName = input.getAttribute('data-name');
        const value = this.getNumericValue(input.value);
        const min = this.getNumericValue(input.getAttribute('data-min'));
        const max = this.getNumericValue(input.getAttribute('data-max'));

        if (Number.isNaN(value)) return;

        if (!Number.isNaN(min) && value < min) input.value = min;
        if (!Number.isNaN(max) && value > max) input.value = max;

        if (priceDataName) {
            this.querySelectorAll(`input[name="${priceDataName}"]`).forEach(inputEl => {
                inputEl.value = input.value;
            });
            this.querySelectorAll('input[type="range"]').forEach(element => {
                // element.setAttribute('disabled', 'true');
                let inputLabel = this.querySelector(`#${element.name}`);
                if (inputLabel) {
                    inputLabel.classList.add('d-none');
                }
            })
        }
    }

    getNumericValue(value) {
        const normalizedValue = String(value || '').replace(/[^0-9.-]/g, '');
        return normalizedValue === '' ? NaN : Number(normalizedValue);
    }

    updateLabelPosition(input, inputLabel) {
        inputLabel.classList.remove('d-none');

        const value = input.value;
        inputLabel.textContent = value;
        const percent = (value - input.min) / (input.max - input.min);

        const thumbWidth = 20;
        const trackWidth = input.clientWidth - thumbWidth;

        const labelPosition = percent * trackWidth;
        inputLabel.style.left = `${labelPosition + thumbWidth / 2}px`;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);
